import React, { useState, useEffect } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { navigationLinks } from '../data/mockData';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when clicking outside
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileMenuOpen]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || mobileMenuOpen ? 'bg-white shadow-md py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="container mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_youth-care-hub-1/artifacts/l12ezb91_Naamloos.png" 
            alt="KS Care Logo" 
            className="h-12 w-auto"
          />
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          {navigationLinks.map((link, index) => (
            <a
              key={index}
              href={link.href}
              className={`text-sm font-medium transition-colors duration-200 hover:text-[#FF6347] ${
                index === 0 ? 'text-[#FF6347]' : 'text-[#1A4D4D]'
              }`}
            >
              {link.name}
            </a>
          ))}
        </nav>

        {/* Right side - Phone & CTA */}
        <div className="flex items-center gap-4">
          <a
            href="tel:0619199023"
            className="hidden lg:flex items-center gap-2 text-[#1A4D4D] hover:text-[#FF6347] transition-colors duration-200"
          >
            <Phone className="w-4 h-4" />
            <span className="text-sm font-medium">06-19199023</span>
          </a>
          <Button
            className="hidden md:block bg-[#FF6347] hover:bg-[#FF5533] text-white rounded-full px-6 transition-all duration-300 hover:shadow-lg"
            onClick={() => window.location.href = 'mailto:info@kscare.nl'}
          >
            Contact
          </Button>
          
          {/* Mobile menu button */}
          <button
            className="md:hidden p-2 bg-white/90 rounded-lg shadow-md text-[#1A4D4D] hover:text-[#FF6347] transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t">
          <nav className="container mx-auto px-6 py-4">
            <div className="flex flex-col space-y-4">
              {navigationLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className={`text-lg font-medium py-2 border-b border-gray-100 transition-colors duration-200 hover:text-[#FF6347] ${
                    index === 0 ? 'text-[#FF6347]' : 'text-[#1A4D4D]'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <a
                href="tel:0619199023"
                className="flex items-center gap-2 text-[#1A4D4D] hover:text-[#FF6347] py-2 border-b border-gray-100"
                onClick={() => setMobileMenuOpen(false)}
              >
                <Phone className="w-5 h-5" />
                <span className="text-lg font-medium">06-19199023</span>
              </a>
              <a 
                href="mailto:info@kscare.nl"
                onClick={() => setMobileMenuOpen(false)}
              >
                <Button className="w-full bg-[#FF6347] hover:bg-[#FF5533] text-white rounded-full py-3 text-lg mt-2">
                  Contact
                </Button>
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;